// @flow
import React, { type Element } from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { hot } from 'react-hot-loader';
import { get, map, isNull } from 'lodash';
import { EllipsedPagination, Grid, Row, Col, Table } from 'angieslist-react-components';
import { analytics, tracker } from 'angieslist-app-platform';
import Helmet from 'react-helmet-async';
import Moment from 'moment';
import * as paginationUtils from 'angieslist-app-platform/lib/common/utils/paginationUtils';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import performanceActions from '../common/performanceActions';
import { defaultPageProps } from '../../../app/browser/analyticsDefaultProperties';
import type { CallLogReducerState } from '../common/performanceReducer';
import './CallLog.scss';

export type CallLogProps = {
  performance: CallLogReducerState,
  getCallLogByServiceProvider: typeof performanceActions.getCallLogByServiceProvider,
  params: {
    serviceProviderId: number
  },
};

type State = {
  pageIndex: number,
};

export class CallLogComponent extends React.Component<CallLogProps, State> {
  constructor(props: CallLogProps) {
    super(props);
    this.state = { pageIndex: 0 };
  }
  state: State;
  componentDidMount() {
    const offset = 0;
    const numberOfEntries = 25;
    const { serviceProviderId } = this.props.params;
    const { getCallLogByServiceProvider } = this.props;
    getCallLogByServiceProvider({ serviceProviderId, offset, numberOfEntries });
  }

  props: CallLogProps;
  render(): Element<"div"> {
    const {
      performance: {
        callLog: {
          response: callLog,
          isLoading,
        },
      },
      getCallLogByServiceProvider,
    } = this.props;

    const parsedDate = (call) => {
      const localDate = Moment(call.date);
      return {
        localDate: localDate.format('L'),
        time: call.displayTime ? localDate.format('h:mm A') : 'N/A',
      };
    };

    const { pageIndex } = this.state;
    const numberOfEntries = 25;
    const pageCount = paginationUtils.getPageCount(get(callLog, 'totalCalls', false), numberOfEntries);
    const callLogResponse = get(callLog, 'phoneCalls', false);

    const parsedLocalDate = map(callLogResponse, call => ({ ...call, date: parsedDate(call) }));

    const totalCalls = get(callLog, 'totalCalls', false);

    return (
      <div id="Call-Log-Container" style={{ background: 'white', paddingTop: 0, marginTop: '-1.25em' }}>
        <Grid>
          <Helmet title="Customer Call Log" />
          <Row>
            <Col xs={12}>
              <h1 style={{ marginBottom: '.8em' }}>Customer Call Log</h1>
              <Loader
                loading={isLoading}
                element={
                  <Row className="category-row text-center" style={{ marginTop: '1em' }}>
                    <i className="icon icon-load icon-spin icon-3x text-primary" />
                  </Row>}

              >
                <Choose>
                  <When condition={callLogResponse && !isLoading}>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Phone Number</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Call Duration (m:s)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(parsedLocalDate, entry => (
                          <tr key={entry.date}>
                            <td>{entry.number}</td>
                            <td>{entry.date.localDate}</td>
                            <td>{entry.date.time}</td>
                            <td>{!entry.duration || isNull(entry.duration) ? 'N/A' : Moment(entry.duration * 1000).format('m:ss')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </When>
                </Choose>
                <If condition={totalCalls === 0}>
                  <p>No calls available</p>
                </If>
              </Loader>
            </Col>
          </Row>
          <If condition={pageCount > 1}>
            <Row>
              <Col>
                <EllipsedPagination
                  pageCount={pageCount}
                  pageIndex={pageIndex}
                  onChange={(i) => {
                    const { serviceProviderId } = this.props.params;
                    const offset = paginationUtils.getOffset((i + 1), 25);
                    getCallLogByServiceProvider({ serviceProviderId, offset, numberOfEntries });
                    this.setState(() => ({ pageIndex: i }));
                    tracker.track('Item Clicked', {
                      serviceProviderId,
                      description: `Page ${(i + 1)}`,
                      activityLocation: 'SP : Call Log',
                      userId: get(this, 'props.user.userInfo.response.userId'),
                    });
                  }}
                />
              </Col>
            </Row>
          </If>
        </Grid>
      </div>
    );
  }
}

const CallLogAnalytics = {
  page: {
    name: 'SP : Customer Call Log',
    properties: defaultPageProps,
  },
};

export default (hot(module)(compose(
  analytics({
    ruleset: CallLogAnalytics,
  }),
  connect(state => ({
    performance: state.performance,
  }), {
    ...performanceActions,
  }),
  pure,
)(CallLogComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/CallLog.js